export default __webpack_public_path__ + "static/media/delete_dev.e915b46c.svg";